export default __webpack_public_path__ + "static/hw_buzzer-6f9377d898a1a01ba43824752bb6b727.jpg";